import React, { useEffect } from 'react';
import { Route, Switch } from 'Components/UI/FacetRouter/FacetRouter';
import { advisorPage, advisorPath } from 'Consts/Strings';
import Page from 'Views/Page';
import { useLocation } from 'react-router-dom';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import AppLayout from 'Components/UI/Navigation/Layouts/DesktopLayout';
import advisorSchema from 'Components/UI/Navigation/Schema/advisor';
import MainContent from 'Components/AdvisorApp/MainContent';
import StatusIndicator from 'Components/UI/StatusIndicator';
import Header from 'Components/AdvisorApp/Header/Header';

const AdvisorContentRouter = () => {
  const { search } = useLocation();
  const { setHouseholdId, householdId } = useSimpleHousehold();

  useEffect(() => {
    const newHouseholdId = new URLSearchParams(search).get('householdId');
    if (newHouseholdId && newHouseholdId !== householdId) {
      setHouseholdId(newHouseholdId);
    }
  }, [search]);

  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Advisor App',
  });

  return (
    <AppLayout
      schema={advisorSchema}
      {...rootNodeProps}
    >
      <StatusIndicator />
      <Header />
      <Switch>
        <Route path={advisorPage} component={Page} />
        <Route path={advisorPath} component={MainContent} />
      </Switch>
    </AppLayout>
  );
};

export default AdvisorContentRouter;
